module.exports = __webpack_public_path__ + "img/Officechair.4843bc7c.svg";